module.exports = __webpack_public_path__ + "img/easy_to_reach_participants.60bbc704.png";